import { selectors } from '@elab/core/store/global';

import { store as getStore } from '../../store/store';

export const application = {
    get language() {
        return selectors.getLanguage(getStore().getState());
    },
    get baseSiteId() {
        return selectors.getSite(getStore().getState());
    },
    get availableLanguages() {
        return selectors.getAvailableLanguages(getStore().getState());
    },
    get occBaseUri() {
        return selectors.getOccBaseUri(getStore().getState());
    },
    get country() {
        return selectors.getCountry(getStore().getState());
    },
    countryKey: 'country',
    languageKey: 'lang',
};
